import React from 'react';
import { Container } from '@mui/material';
import GoalWritingAssistant from '../components/GoalWritingAssistant';

const GoalWritingAssistantPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <GoalWritingAssistant />
    </Container>
  );
};

export default GoalWritingAssistantPage;